module.exports = __webpack_public_path__ + "img/user-fallback.68f1d945.svg";